// Build the same panel shape used by the existing Configuration components.
const readField = (value, fallback) => {
  if (value == null) return fallback;
  if (typeof value !== "string") return value;
  try { return JSON.parse(value); } catch { return fallback; }
};

export const panelFromProjectDocument = (doc, metadata = {}) => {
  const fields = {
    ArgusTablePr: ["argustablepr", []], Codes: ["codes", {}],
    DaylightSaving: ["daylightsaving", {}], FlogicPr: ["flogicpr", []],
    GeneralParameters: ["generalparameters", {}], Holidays: ["holidays", []],
    OutputZones: ["outputzones", []], TimeIntervals: ["timeintervals", []],
    VTNet: ["vtnets", []], WeeklyTrends: ["weeklytrends", []],
    ZoneTable: ["zonetable", []], Dependency: ["dependency", []],
  };
  const extra = readField(doc.workflow_config_extra, {});
  const config = { ...(extra && typeof extra === "object" ? extra : {}) };
  for (const [key, [dbField, fallback]] of Object.entries(fields)) {
    config[key] = readField(doc[dbField] ?? doc[key], fallback);
  }
  return {
    ...metadata,
    ...doc,
    panelContent_id: doc.panelContent_id,
    panelNumber: metadata.panelNumber ?? Number(config.GeneralParameters?.vtnetPanelAddress),
    VT5000_CONFIG: config,
  };
};
